/**
 * directorsStore — Zustand store that controls the global Directors modal.
 *
 * Any node (or button) can invoke `open({ nodeId, nodeType, currentPrompt, onInsert })`
 * to open the modal. When the user confirms the Master Prompt, `onInsert(text)`
 * is called with the final prompt so the invoking node can set its own state.
 */
import { create } from 'zustand';

export const useDirectorsStore = create((set) => ({
  isOpen: false,
  nodeId: null,
  nodeType: null,
  currentPrompt: '',
  onInsert: null,      // (finalPrompt: string) => void

  open: ({ nodeId, nodeType, currentPrompt, onInsert }) => set({
    isOpen: true,
    nodeId,
    nodeType,
    currentPrompt: currentPrompt || '',
    onInsert: typeof onInsert === 'function' ? onInsert : null,
  }),

  close: () => set({
    isOpen: false,
    nodeId: null,
    nodeType: null,
    currentPrompt: '',
    onInsert: null,
  }),
}));

export default useDirectorsStore;
